export const translations = {
  en: {
    base_page: {
      contact_link_text: 'Contact Us'
    },
    home_page: {
      title: [
        'Software',
        'Native Apps',
        'Digital design',
        'Web apps',
        'DevOps',
        'Ecommerce'
      ],
      subtitle: 'is what we do'
    },
    contact_page: {
      title: "Let's",
      subtitle: 'Talk !',
      form: {
        placeholder_name: 'your name',
        placeholder_email: 'email',
        placeholder_message: 'feel free to say whatever you want ;)'
      },
      address: {
        title: 'Address',
        line1: 'Rua Cincinato Braga, 414 - ap 91 / 01333-010',
        line2: 'São Paulo - Brazil'
      },
      contacts: {
        title: 'The Old & Good Way'
      }
    },
    project_page: {
      subtitle: 'Projects'
    },
    menu: {
      projects: 'Projects',
      contact: 'Contact Us'
    }
  },
  pt: {
    base_page: {
      contact_link_text: 'Entre em contato'
    },
    home_page: {
      title: [
        'Software',
        'Apps nativos',
        'Design digital',
        'Web apps',
        'DevOps',
        'Sistemas',
        'Ecommerce'
      ],
      subtitle: 'is what we do'
    },
    contact_page: {
      title: 'Vamos',
      subtitle: 'Conversar',
      form: {
        placeholder_name: 'seu nome',
        placeholder_email: 'email',
        placeholder_message: 'diga o que você quiser ;)'
      },
      address: {
        title: 'Endereço',
        line1: 'Rua Cincinato Braga, 414 / 01333-010',
        line2: 'São Paulo / SP - Brasil'
      },
      contacts: {
        title: 'Do Bom & Velho Jeito'
      }
    },
    project_page: {
      subtitle: 'Projetos'
    },
    menu: {
      projects: 'Projetos',
      contact: 'Entre em contato'
    }
  }
};



// WEBPACK FOOTER //
// ./src/constants/translations.js